"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var helpers_1 = require("./helpers");

var psdReader_1 = require("./psdReader");

function readBlendMode(reader) {
  psdReader_1.checkSignature(reader, '8BIM');
  return psdReader_1.readSignature(reader);
}

function readShadowInfo(reader) {
  var size = psdReader_1.readUint32(reader);
  var version = psdReader_1.readUint32(reader);
  if (size !== 41 && size !== 51) throw new Error("Invalid effects shadow info size: " + size);
  if (version !== 0 && version !== 2) throw new Error("Invalid effects shadow info version: " + version);
  var blur = psdReader_1.readInt32(reader);
  var intensity = psdReader_1.readInt32(reader);
  var angle = psdReader_1.readInt32(reader);
  var distance = psdReader_1.readInt32(reader);
  var color = helpers_1.readColor(reader);
  var blendMode = readBlendMode(reader);
  var enabled = !!psdReader_1.readUint8(reader);
  var useAngleInAllEffects = !!psdReader_1.readUint8(reader);
  var opacity = psdReader_1.readUint8(reader);
  var nativeColor = size >= 51 ? helpers_1.readColor(reader) : undefined;
  return {
    blur: blur,
    intensity: intensity,
    angle: angle,
    distance: distance,
    color: color,
    blendMode: blendMode,
    enabled: enabled,
    useAngleInAllEffects: useAngleInAllEffects,
    opacity: opacity,
    nativeColor: nativeColor
  };
}

function readOuterGlowInfo(reader) {
  var size = psdReader_1.readUint32(reader);
  var version = psdReader_1.readUint32(reader);
  if (size !== 32 && size !== 42) throw new Error("Invalid effects outer glow info size: " + size);
  if (version !== 0 && version !== 2) throw new Error("Invalid effects outer glow info version: " + version);
  var blur = psdReader_1.readUint32(reader);
  var intensity = psdReader_1.readUint32(reader);
  var color = helpers_1.readColor(reader);
  var blendMode = readBlendMode(reader);
  var enabled = !!psdReader_1.readUint8(reader);
  var opacity = psdReader_1.readUint8(reader);
  var nativeColor = size >= 42 ? helpers_1.readColor(reader) : undefined;
  return {
    blur: blur,
    intensity: intensity,
    color: color,
    blendMode: blendMode,
    enabled: enabled,
    opacity: opacity,
    nativeColor: nativeColor
  };
}

function readInnerGlowInfo(reader) {
  var size = psdReader_1.readUint32(reader);
  var version = psdReader_1.readUint32(reader);
  if (size !== 33 && size !== 43) throw new Error("Invalid effects inner glow info size: " + size);
  if (version !== 0 && version !== 2) throw new Error("Invalid effects inner glow info version: " + version);
  var blur = psdReader_1.readUint32(reader);
  var intensity = psdReader_1.readUint32(reader);
  var color = helpers_1.readColor(reader);
  var blendMode = readBlendMode(reader);
  var enabled = !!psdReader_1.readUint8(reader);
  var opacity = psdReader_1.readUint8(reader);
  var invert = size >= 43 ? !!psdReader_1.readUint8(reader) : undefined;
  var nativeColor = size >= 43 ? helpers_1.readColor(reader) : undefined;
  return {
    blur: blur,
    intensity: intensity,
    color: color,
    blendMode: blendMode,
    enabled: enabled,
    opacity: opacity,
    invert: invert,
    nativeColor: nativeColor
  };
}

function readBevelInfo(reader) {
  var size = psdReader_1.readUint32(reader);
  var version = psdReader_1.readUint32(reader);
  if (size !== 58 && size !== 78) throw new Error("Invalid effects bevel info size: " + size);
  if (version !== 0 && version !== 2) throw new Error("Invalid effects bevel info version: " + version);
  var angle = psdReader_1.readUint32(reader);
  var strength = psdReader_1.readUint32(reader);
  var blur = psdReader_1.readUint32(reader);
  var highlightBlendMode = readBlendMode(reader);
  var shadowBlendMode = readBlendMode(reader);
  var highlightColor = helpers_1.readColor(reader);
  var shadowColor = helpers_1.readColor(reader);
  var bevelStyle = psdReader_1.readUint8(reader);
  var highlightOpacity = psdReader_1.readUint8(reader);
  var shadowOpacity = psdReader_1.readUint8(reader);
  var enabled = !!psdReader_1.readUint8(reader);
  var useAngleInAllEffects = !!psdReader_1.readUint8(reader);
  var up = !!psdReader_1.readUint8(reader);
  var realHighlightColor = size >= 78 ? helpers_1.readColor(reader) : undefined;
  var realShadowColor = size >= 78 ? helpers_1.readColor(reader) : undefined;
  return {
    angle: angle,
    strength: strength,
    blur: blur,
    highlightBlendMode: highlightBlendMode,
    shadowBlendMode: shadowBlendMode,
    highlightColor: highlightColor,
    shadowColor: shadowColor,
    bevelStyle: bevelStyle,
    highlightOpacity: highlightOpacity,
    shadowOpacity: shadowOpacity,
    enabled: enabled,
    useAngleInAllEffects: useAngleInAllEffects,
    up: up,
    realHighlightColor: realHighlightColor,
    realShadowColor: realShadowColor
  };
}

function readSolidFillInfo(reader) {
  var size = psdReader_1.readUint32(reader);
  var version = psdReader_1.readUint32(reader);
  if (size !== 34) throw new Error("Invalid effects solid fill info size: " + size);
  if (version !== 2) throw new Error("Invalid effects solid fill info version: " + version);
  var blendMode = readBlendMode(reader);
  var color = helpers_1.readColor(reader);
  var opacity = psdReader_1.readUint8(reader);
  var enabled = !!psdReader_1.readUint8(reader);
  var nativeColor = helpers_1.readColor(reader);
  return {
    blendMode: blendMode,
    color: color,
    opacity: opacity,
    enabled: enabled,
    nativeColor: nativeColor
  };
}

function readEffects(reader) {
  var version = psdReader_1.readUint16(reader);
  if (version !== 0) throw new Error("Invalid effects layer version: " + version);
  var effectsCount = psdReader_1.readUint16(reader);
  var effects = {};

  for (var i = 0; i < effectsCount; i++) {
    psdReader_1.checkSignature(reader, '8BIM');
    var type = psdReader_1.readSignature(reader);

    switch (type) {
      case 'cmnS':
        // common state (see See Effects layer, common state info)
        var size = psdReader_1.readUint32(reader);
        var version_1 = psdReader_1.readUint32(reader);
        var visible = !!psdReader_1.readUint8(reader);
        psdReader_1.skipBytes(reader, 2);
        if (size !== 7 || version_1 !== 0 || !visible) throw new Error("Invalid effects common state");
        break;

      case 'dsdw':
        // drop shadow (see See Effects layer, drop shadow and inner shadow info)
        effects.dropShadow = readShadowInfo(reader);
        break;

      case 'isdw':
        // inner shadow (see See Effects layer, drop shadow and inner shadow info)
        effects.innerShadow = readShadowInfo(reader);
        break;

      case 'oglw':
        // outer glow (see See Effects layer, outer glow info)
        effects.outerGlow = readOuterGlowInfo(reader);
        break;

      case 'iglw':
        // inner glow (see See Effects layer, inner glow info)
        effects.innerGlow = readInnerGlowInfo(reader);
        break;

      case 'bevl':
        // bevel (see See Effects layer, bevel info)
        effects.bevel = readBevelInfo(reader);
        break;

      case 'sofi':
        // solid fill ( Photoshop 7.0) (see See Effects layer, solid fill (added in Photoshop 7.0))
        effects.solidFill = readSolidFillInfo(reader);
        break;

      default:
        throw new Error("Invalid effect type: '" + type + "'");
    }
  }

  return effects;
}

exports.readEffects = readEffects;

function writeEffects(_writer, _effects) {
  throw new Error('Not implemented');
}

exports.writeEffects = writeEffects;